<template>
	<div id="journalism">
		<section>
			<div v-if="newsAdvList.length" style="display: flex;">
				<div @click="hotNewsClick('left',newsAdvList[0])" style="width: 360px;height: 540px;">
					<img :src="newsAdvList[0].imageUrl" style="width: 100%;height: 100%;" />
				</div>
				<div style="margin-left: 20px;position: relative;width: 620px;">
					<div @click="hotNewsClick('right',newsAdvList[1])">
						<img :src="newsAdvList[1].imageUrl" style="width: 100%;height: 300px;" />
					</div>
					<div>
						<img class="hotNews" :src="newsAdvList[2].imageUrl" style="left: 0;" @click="hotNewsClick('dowLeft',newsAdvList[2])" />
						<img class="hotNews" :src="newsAdvList[3].imageUrl" style="right: 0;" @click="hotNewsClick('dowRight',newsAdvList[3])" />
					</div>
				</div>
			</div>
			<p>
				<img src="../images/icon/news_line.png" style="width: 100%;" />
			</p>
		</section>
		<section>
			<article v-for="item in dataLsit">
				<div class="newsItem" style="display: flex;" @click="newsClick(item)">
					<div style="width:300px;height: 200px;">
						<img :src="item.thumbnailUrl" style="height: 100%" />
					</div>
					<div class="newsContent">
						<h4 v-text="item.title"></h4>
						<p v-text="item.summary" style="white-space: normal;word-break: break-all;font-size: 20px;line-height: 25px;color: #333;"></p>
						<p class="timeWarpper">
							<img src="../images/icon/time.png" style="vertical-align: middle;" />
							<span v-text="computeTime(item.updatedAt)"></span>
						</p>
					</div>
				</div>
				<img class="newsLine" src="../images/icon/news_line.png" />
			</article>
			<article>
				<ul id="pagination">
					<li>
						<a @click="jumpPge('homePage')">首页</a>
					</li>
					<li>
						<a @click="jumpPge('prevPage')">上一页</a>
					</li>
					<li>
						<span style="line-height: 27px;"><i v-text="currentPage">0</i><i>/</i><i v-text="totalPage">0</i></span>
					</li>
					<li>
						<a @click="jumpPge('nextPage')">下一页</a>
					</li>
					<li style="border: none;" @click="jumpPge('lastPage')">
						<a>尾页</a>
					</li>
				</ul>
			</article>
		</section>
	</div>
</template>

<script>
	var _this;
	export default {
		name: 'journalism',
		data() {
			return {
				dataLsit: [], // 新闻列表
				newsAdvList: [], // 新闻广告位列表
				currentPage: 1, // 当前页码
				rePage:0,  // 请求中的页码
				totalPage: 1, // 总页码
				pageSize: 5, // 一页显示新闻数量
			}
		},
		//监听
		watch: {
			currentPage: function(page) {}
		},

		//实例加载完成后
		created() {},

		//页面完成以后
		mounted: function() {
			_this = this;
			this.requestRecommendNewsList();
			this.requestNewsList(0);
		},

		methods: {
			// 时间戳计算
			computeTime: function(d) {
				return this.appfn.creatTime(d);
			},
			// 热门新闻点击事件
			hotNewsClick: function(name, item) {
				//				switch(name) {
				//					case 'left':
				//						break;
				//					case 'right':
				//						break;
				//					case 'dowLeft':
				//						break;
				//					case 'dowRight':
				//						break;
				//					default:
				//						alert('链接打开失败');
				//				}
				window.open(item.hyperlink);
			},
			// 页码跳转
			jumpPge: function(name) {
				
					if(name=='homePage'){
					if(this.currentPage==1){
						return;
					}else{
						this.currentPage=1;
						this.rePage=0;
						this.requestNewsList(0);
					}
				}else if(name == 'prevPage'){
					if(this.currentPage<=1){
						this.rePage=0;
						return;
					}else{
						this.currentPage-=1;
						this.rePage-=1;
						this.requestNewsList(this.rePage*this.pageSize);
					}
					
				}else if(name == 'nextPage'){
					if(this.currentPage==this.totalPage){
						this.rePage=this.totalPage-1;
						return;
					}else{
						this.currentPage+=1;
						this.rePage+=1;
						this.requestNewsList(this.rePage*this.pageSize);
					}
				}else if(name == 'lastPage'){
					if(this.currentPage==this.totalPage){
						this.rePage=this.totalPage-1;
						return;
					}else{
						this.currentPage=this.totalPage;
						this.rePage=this.totalPage-1;
						this.requestNewsList(this.rePage*this.pageSize);
					}
				}
			},
			// 新闻点击事件
			newsClick: function(item) {
				console.log(112,item)
				if(item.type==2) { // 超链接
					window.open(item.hyperlink);
				} else {
					window.open('http://www2t.edgteam.cn/newsDetail.html?id=' + item.id); 
				}
			},
			//--------------------------------------
			// 获取新闻广告位列表
			requestRecommendNewsList: function(offset) {
				this.request.get({
					url: '/ad/news?condition=status=0',
					params: {},
					callback: function(d) {
						this.newsAdvList = [];
						if(d.data.length == 0) return;
						for(var i = 0; i < d.data[0].details.length; i++) {
							this.newsAdvList.push(d.data[0].details[i])
						}
						console.log('获取新闻广告位列表：', this.newsAdvList);

					}.bind(this)
				})
			},
			// 获取新闻列表
			requestNewsList: function(offset) {
				this.request.get({
					url: '/edg/post',
					params: {
						'size': this.pageSize,
						'offset': offset ? offset : 0,
						'condition': 'status=0',
						'exclude': 'text',
					},
					callback: function(d) {
						if(d.total==0){
							$('#pagination').css('display','none');
							return
						}
						this.dataLsit = d.data;
						this.totalPage = Math.ceil(d.total / this.pageSize);
						console.log('获取新闻列表', d);

					}.bind(this)
				})
			}
		}
	}
	
</script>

<style scoped>
	#journalism {
		width: 60%;
		min-width: 1080px;
		margin: 0 auto;
		margin-top: 70px;
		min-height: 700px;
	}
	
	.hotNews {
		width: 48.5%;
		height: 230px;
		position: absolute;
		bottom: 0;
	}
	
	.newsContent {
		box-sizing: border-box;
		padding-left: 50px;
		position: relative;
		width: 100%;
	}
	
	.newsContent>h4 {
		margin-top: 0;
		margin-bottom: 22px;
		font-size: 30px;
		color: #000;
		font-weight: 500;
	}
	
	.newsContent .timeWarpper {
		margin-bottom: 0;
		position: absolute;
		bottom: 0;
		right: 0;
	}
	
	img.newsLine {
		width: 100%;
		height: 1px;
		margin: 20px 0;
	}
	
	#pagination {
		text-align: center;
		font-size: 0;
		padding: 30px 0;
	}
	
	#pagination li {
		display: inline-block;
		font-size: 20px;
		padding: 3px 10px;
		border-right: 1px solid #0f71bb;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	#pagination li a {
		cursor: pointer;
	}
	
	#pagination li:hover {
		background: #ddd;
	}
	
	.newsItem:hover {
		background: #ddd;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/journalism.vue